var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "gallery-picker",
    class: {
      'gallery-picker--picker': _vm.mode === 'picker'
    }
  }, [_c('div', {
    staticClass: "gallery-sidebar"
  }, [_c('div', {
    staticClass: "sidebar-item",
    class: {
      active: !_vm.activeDirectoryId
    },
    on: {
      "click": function ($event) {
        return _vm.handleSelectDirectory(null);
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-folder"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('sc.gallery.allMaterials')))])]), _vm._v(" "), _vm.directoryTree.length ? _c('el-tree', {
    ref: "directoryTreeRef",
    attrs: {
      "data": _vm.directoryTree,
      "props": _vm.treeProps,
      "node-key": "id",
      "highlight-current": true,
      "expand-on-click-node": true,
      "default-expand-all": true
    },
    on: {
      "node-click": _vm.handleTreeNodeClick
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var node = _ref.node,
            data = _ref.data;
        return [_c('span', {
          staticClass: "tree-node-label",
          on: {
            "contextmenu": function ($event) {
              $event.preventDefault();
              return _vm.handleTreeContextMenu($event, data);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-folder"
        }), _vm._v(" "), _c('span', {
          staticClass: "tree-node-text",
          attrs: {
            "title": node.label
          }
        }, [_vm._v(_vm._s(node.label))])])];
      }
    }], null, false, 3275834878)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.contextMenu.visible,
      expression: "contextMenu.visible"
    }],
    ref: "contextMenuRef",
    staticClass: "tree-context-menu",
    style: {
      top: _vm.contextMenu.top + 'px',
      left: _vm.contextMenu.left + 'px'
    }
  }, [_c('div', {
    staticClass: "context-menu-item",
    on: {
      "click": _vm.handleRenameFolder
    }
  }, [_c('i', {
    staticClass: "el-icon-edit"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('sc.gallery.renameFolder')))])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-add-folder",
    on: {
      "click": function ($event) {
        _vm.showNewFolderDialog = true;
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('sc.gallery.addFolder')) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "gallery-content"
  }, [_c('div', {
    staticClass: "gallery-toolbar"
  }, [_vm.defaultFileType === 'all' ? _c('div', {
    staticClass: "toolbar-tabs"
  }, [_c('span', {
    staticClass: "tab-item",
    class: {
      active: _vm.activeTab === 'all'
    },
    on: {
      "click": function ($event) {
        return _vm.handleTabChange('all');
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sc.gallery.allMaterials')) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "tab-item",
    class: {
      active: _vm.activeTab === 'image'
    },
    on: {
      "click": function ($event) {
        return _vm.handleTabChange('image');
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sc.gallery.images')) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "tab-item",
    class: {
      active: _vm.activeTab === 'video'
    },
    on: {
      "click": function ($event) {
        return _vm.handleTabChange('video');
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sc.gallery.videos')) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "toolbar-actions"
  }, [_vm.mode === 'page' ? _c('el-checkbox', {
    staticClass: "select-all-checkbox",
    on: {
      "change": _vm.handleSelectAll
    },
    model: {
      value: _vm.isAllSelected,
      callback: function ($$v) {
        _vm.isAllSelected = $$v;
      },
      expression: "isAllSelected"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sc.gallery.selectAll')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function ($event) {
        _vm.showNewFolderDialog = true;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sc.gallery.newFolder')) + "\n        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function ($event) {
        _vm.showUploadDialog = true;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sc.gallery.localUpload')) + "\n        ")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading || _vm.loadingMore,
      expression: "loading || loadingMore"
    }],
    staticClass: "gallery-grid-wrap"
  }, [_c('div', {
    ref: "galleryGrid",
    staticClass: "gallery-grid",
    on: {
      "scroll": _vm.throttledScroll
    }
  }, [_vm._l(_vm.fileList, function (file) {
    return _c('div', {
      key: file.id,
      staticClass: "gallery-item",
      class: {
        selected: _vm.selectedFileIds.includes(file.id),
        referenced: file.isReferenced
      },
      on: {
        "click": function ($event) {
          return _vm.handleFileClick(file);
        }
      }
    }, [_c('div', {
      staticClass: "item-thumbnail"
    }, [_vm.isVideoFile(file) ? [_c('video', {
      staticClass: "video-player",
      attrs: {
        "width": "100%",
        "controls": "controls"
      }
    }, [_c('source', {
      attrs: {
        "src": file.fullUrl,
        "type": "video/mp4"
      }
    })])] : [_c('img', {
      attrs: {
        "src": file.fullUrl || file.thumbnailUrl,
        "alt": file.fileName
      }
    })], _vm._v(" "), file.isReferenced ? _c('div', {
      staticClass: "referenced-badge"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('sc.gallery.referenced')) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm.selectedFileIds.includes(file.id) ? _c('div', {
      staticClass: "item-check-icon"
    }, [_c('span', {
      staticClass: "order-num"
    }, [_vm._v(_vm._s(_vm.getSelectedOrder(file.id)))])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('div', {
      staticClass: "item-name",
      attrs: {
        "title": file.fileName
      }
    }, [_vm._v("\n              " + _vm._s(file.fileName) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "item-meta"
    }, [_vm.formatFileSize(file.fileSize) ? _c('span', [_vm._v(_vm._s(_vm.formatFileSize(file.fileSize)))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDate(file.createdTime)))])]), _vm._v(" "), _c('div', {
      staticClass: "item-hover-actions"
    }, [!file.isReferenced ? _c('span', {
      staticClass: "hover-action",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.handleSingleFileDelete(file);
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete"
    }), _vm._v("\n                " + _vm._s(_vm.$t('sc.gallery.delete')) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "hover-action",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.handlePreviewFile(file);
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-view"
    }), _vm._v("\n                " + _vm._s(_vm.$t('sc.gallery.preview')) + "\n              ")])])])]);
  }), _vm._v(" "), !_vm.loading && _vm.fileList.length === 0 ? _c('div', {
    staticClass: "gallery-empty"
  }, [_c('no-data')], 1) : _vm._e(), _vm._v(" "), _vm.fileList.length > 0 && (_vm.loadingMore || !_vm.hasMore) ? _c('div', {
    staticClass: "grid-loadmore-status"
  }, [_vm.loadingMore ? _c('span', [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v("\n            " + _vm._s(_vm.$t('sc.gallery.loadingMore')) + "\n          ")]) : _c('span', [_vm._v(_vm._s(_vm.$t('sc.gallery.noMore', {
    n: _vm.pagination.total
  })))])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "gallery-footer",
    class: {
      'is-picker': _vm.mode === 'picker'
    }
  }, [_c('div', {
    staticClass: "footer-left"
  }, [_vm.mode === 'page' && _vm.selectedFileIds.length > 0 ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.handleDeleteFiles
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sc.gallery.delete')) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm.mode === 'picker' && _vm.maxSelect > 0 ? _c('span', {
    staticClass: "picker-counter"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sc.gallery.selectedCount', {
    n: _vm.selectedFileIds.length,
    max: _vm.maxSelect
  })) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-right"
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sc.gallery.shownProgress', {
    shown: _vm.fileList.length,
    total: _vm.pagination.total
  })) + "\n        ")]), _vm._v(" "), _vm.mode === 'picker' ? [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('sc.gallery.closeGallery')) + "\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "disabled": _vm.selectedFileIds.length === 0
    },
    on: {
      "click": _vm.handleConfirmSelect
    }
  }, [_vm._v("\n            " + _vm._s(_vm.useSelectedLabel) + "\n          ")])] : _vm._e()], 2)])]), _vm._v(" "), _c('NewFolderDialog', {
    attrs: {
      "visible": _vm.showNewFolderDialog,
      "directory-tree": _vm.directoryTree
    },
    on: {
      "update:visible": function ($event) {
        _vm.showNewFolderDialog = $event;
      },
      "created": _vm.handleFolderCreated
    }
  }), _vm._v(" "), _c('UploadDialog', {
    attrs: {
      "visible": _vm.showUploadDialog,
      "directory-tree": _vm.directoryTree
    },
    on: {
      "update:visible": function ($event) {
        _vm.showUploadDialog = $event;
      },
      "uploaded": _vm.handleFileUploaded
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('sc.gallery.renameFolderTitle'),
      "visible": _vm.renameDialog.visible,
      "width": "420px",
      "append-to-body": "",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.renameDialog, "visible", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.renameDialog.submitting
          },
          on: {
            "click": _vm.submitRenameFolder
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('sc.gallery.confirm')) + "\n      ")]), _vm._v(" "), _c('el-button', {
          on: {
            "click": function ($event) {
              _vm.renameDialog.visible = false;
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('sc.gallery.cancel')) + "\n      ")])];
      },
      proxy: true
    }])
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('sc.gallery.newFolderNameLabel')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('sc.gallery.newFolderNamePlaceholder')
    },
    model: {
      value: _vm.renameDialog.newName,
      callback: function ($$v) {
        _vm.$set(_vm.renameDialog, "newName", $$v);
      },
      expression: "renameDialog.newName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "preview-dialog",
    attrs: {
      "visible": _vm.previewDialog.visible,
      "title": _vm.previewDialog.fileName,
      "width": "720px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.previewDialog, "visible", $event);
      }
    }
  }, [_c('div', {
    staticClass: "preview-content"
  }, [_vm.previewDialog.isVideo ? _c('video', {
    staticClass: "preview-media-video",
    attrs: {
      "src": _vm.previewDialog.url,
      "controls": "controls"
    }
  }) : _c('img', {
    staticClass: "preview-media",
    attrs: {
      "src": _vm.previewDialog.url,
      "alt": _vm.previewDialog.fileName
    }
  })])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }